import { useIxcAssetsV1AssetQueryServiceAssetGet } from '@interxfi/api-client/generated/hooks/ixc-assets-v1-asset-query-service-asset-get';
import { getShortenedId } from '@interxfi/design-system/components/format/id/shared';
import { Skeleton } from '@interxfi/design-system/components/loading/skeleton';
import { getAssetSymbol } from '../../asset/utils';

interface SweepBalanceBreadcrumbProps {
  assetId: string;
}

export function SweepBalanceBreadcrumb({ assetId }: SweepBalanceBreadcrumbProps) {
  const { data, isPending } = useIxcAssetsV1AssetQueryServiceAssetGet({ assetId });

  if (isPending) {
    return <Skeleton charCount={14} />;
  }

  return `Swept to ${getAssetSymbol(data?.asset?.data?.type) || getShortenedId(assetId)}`;
}
